import {
  FaCoffee,
  FaHamburger,
  FaPizzaSlice,
  FaIceCream,
  FaWineGlass,
  FaUtensils,
  FaFish,
  FaDrumstickBite,
  FaCheese,
  FaAppleAlt,
} from "react-icons/fa";

export const categoryIconsMap = {
  FaCoffee,
  FaHamburger,
  FaPizzaSlice,
  FaIceCream,
  FaWineGlass,
  FaUtensils,
  FaFish,
  FaDrumstickBite,
  FaCheese,
  FaAppleAlt,
};
